<template>
  <div class="app-container Srctwo4">
    <img src="../../assets/satistics/img-bottom-pattern.png" alt="" class="back_pattern">
    <div class="one_title" style="left: 8%;">
      <div style="position:relative;width: 100%;height: 100%">
        <img src="../../assets/satistics/icon-title-back.png" alt="" class="one_title_back">
        <span class="one_title_text">资产管理</span>
      </div>
    </div>
    <div class="one_title" style="left: 67.5%;">
      <div style="position:relative;width: 100%;height: 100%">
        <img src="../../assets/satistics/icon-title-back.png" alt="" class="one_title_back">
        <span class="one_title_text">资源管理</span>
      </div>
    </div>
    <div class="total_property">
      <div style="position:relative;width: 100%;height: 100%;">
        <img src="../../assets/satistics/img_total_propterty.png" alt="" class="total_property_back">
        <div class="total_property_text">
          <div class="total_property_name">资产统计（万元）</div>
          <div class="total_property_num">33585.5</div>
        </div>
        <img src="../../assets/satistics/svg-circle.svg" alt="" class="anima_border">
        <div class="anima_pattern">
          <div class="anima_outer">
            <div class="anima_inner"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="second_title" style="position:absolute;top:30%;left: 6%;">
      <div style="position:relative;display: flex;justify-content: space-between;align-items: center">
        <div class="title_text">资产类型</div>
        <div class="title_pattern"></div>
        <div class="title_light"></div>
      </div>
    </div>
    <div class="content_pad" style="position:absolute;top:34%;left: 6%;width:24%;height: 20%">
      <ec-pie style="height: 100%;width: 100%" type="小环比" unit="(万元)" :data="propertiesRatePie"></ec-pie>
    </div>
    <div class="second_title" style="position:absolute;top:56%;left: 8%;">
      <div style="position:relative;display: flex;justify-content: space-between;align-items: center">
        <div class="title_text">负债及所有者权益</div>
        <div class="title_pattern"></div>
        <div class="title_light"></div>
      </div>
    </div>
    <div class="content_pad" style="position:absolute;top:61%;left: 8%;width:24%;height: 30%">
      <div class="loan_money">
        <img src="../../assets/satistics/img-loan-back.png" alt="" class="loan_img">
        <div class="loan_text">
          <span class="loan_name">所有者权益(万元)</span>
          <span class="loan_num">{{ecBarData1[2]}}</span>
        </div>
      </div>
      <ec-bar style="width: 100%;height: 80%" type="cube" :data="ecBarData1" :names="ecBarName1" unit="(万元)"></ec-bar>
    </div>


    <div class="second_title" style="position:absolute;top:20%;left: 69%;">
      <div style="position:relative;display: flex;justify-content: space-between;align-items: center">
        <div class="title_text">建筑用地</div>
        <div class="title_pattern"></div>
        <div class="title_light"></div>
      </div>
    </div>
    <div class="content_pad" style="position:absolute;top:24.5%;left: 69%;width:23%;height: 20%;">
      <div class="place_line" style="width: 100%;height: 45%;">
        <div class="place_item">
          <!-- <div class="place_num">{{placeUsed.storage||0}}</div> -->
          <div class="place_num">350</div>
          <div class="place_name">仓储用地（亩）</div>
        </div>
        <div class="place_item">
          <!-- <div class="place_num">{{placeUsed.commercial||0}}</div> -->
          <div class="place_num">150</div>
          <div class="place_name">商服用地（亩）</div>
        </div>
        <div class="place_item">
          <!-- <div class="place_num">{{placeUsed.village||0}}</div> -->
          <div class="place_num">590</div>
          <div class="place_name">农村宅基地（亩）</div>
        </div>
      </div>
      <div class="place_line" style="width: 100%;height: 50%;margin-top:2%;">
        <div class="place_item">
          <!-- <div class="place_num">{{placeUsed.publicMan||0}}</div> -->
          <div class="place_num">50</div>
          <div class="place_name">公共管理与公共服务用地（亩）</div>
        </div>
        <div class="place_item">
          <!-- <div class="place_num">{{placeUsed.transportation||0}}</div> -->
          <div class="place_num">150</div>
          <div class="place_name">交通运输和水利设施用地（亩）</div>
        </div>
        <div class="place_item">
          <div class="place_num">{{placeUsed.otherContractors||0}}</div>
          <div class="place_name">其他建设用地（亩）</div>
        </div>
      </div>
    </div>
    <div class="second_title" style="position:absolute;top:45.5%;left: 69%;">
      <div style="position:relative;display: flex;justify-content: space-between;align-items: center">
        <div class="title_text">农用地统计</div>
        <div class="title_pattern"></div>
        <div class="title_light"></div>
      </div>
    </div>
    <div class="content_pad" style="position:absolute;top:49%;left: 69%;width:23%;height: 19%;">
      <ec-bar style="width: 100%;height: 100%" type="cube" :data="ecBarData2" :names="ecBarName2" unit="(亩)"></ec-bar>
    </div>
    <div class="second_title" style="position:absolute;top:68%;left: 69%;">
      <div style="position:relative;display: flex;justify-content: space-between;align-items: center">
        <div class="title_text">未利用地</div>
        <div class="title_pattern"></div>
        <div class="title_light"></div>
      </div>
    </div>
    <div class="content_pad" style="position:absolute;top:69%;left: 69%;width:23%;height: 19%;">
      <div style="width: 100%;height: 100%;position:relative;">
        <img src="../../assets/satistics/icon-no-user-place.png" alt="" class="no-use-img">
        <div class="place_text" style="left: 8%;bottom: 8%">
          <div class="place_num">{{unUsedData.rate||0}}</div>
          <div class="place_name">占总面积（%）</div>
        </div>
        <div class="place_text" style="right: 5%;top: 10%">
          <div class="place_num">{{unUsedData.unUsedLand||0}}</div>
          <div class="place_name">未利用地（亩）</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "properties",
    components: {
      ecPie: () => import('./components/ec-pie'),
      ecBar: () => import('./components/ec-bar')
    },
    computed: {},
    data() {
      return {
        propertiesRatePie: [
          {
            name: '流动资产', value: 196375878.76
            , rate: 30
          }, {
            name: '农业资产', value: 12899919.27
            , rate: -16
          }, {
            name: '长期资产', value: 6740000.00
            , rate: 5
          }, {
            name: '固定资产', value: 117993567.83
            , rate: -5
          }, {
            name: '其他资产', value: 1845790.35
            , rate: 12
          }],
        ecBarData1: [],
        ecBarName1: [],
        ecBarName2: [],
        ecBarData2: [],
        placeUsed: {
          storage: 0,    //矿仓储用地-面积
          commercial: 0,    //商服用地
          village: 0,    //农村宅基地
          publicMan: 0,    //公共管理与公共服务用地
          transportation: 0,    //交通运输和水利设施用地
          otherContractors: 0,    //其他建设用地
        },
        unUsedData: {},
        placeData: [],
        placeDataName: []
      }
    },
    created() {
      Promise.all([
        this.getConstructionFormlandArea(),
        this.getCountAssets(),
        this.getLiabilityCount(),
        this.getUnUsedLand()

      ])
    },
    methods: {
      getConstructionFormlandArea() {
        this.$http.get('api/tResourceAsset/getConstructionFormlandArea').then(res => {
          if (res.data.code == 200) {
            let data = res.data.data
            this.ecBarName2 = ['耕地', '园林', '林地', '草地', '农田水利设施用地', '养殖水面', '其他农用地']
            this.ecBarData2 = [data.ploigh, data.park, data.forestArea, data.grassland, data.cropland, data.cultivation, data.otherArea]
            this.placeUsed = data
          }

        })
      },

      getUnUsedLand() {
        this.$http.get('api/tResourceAssetUnUsedLand/getUnUsedLand').then(res => {
          if (res.data.code == 200) {
            this.unUsedData = res.data.data
          }
        })
      },

      getCountAssets() {
        this.$http.get('api/tCountAssets/getCountAssets').then(res => {
          if (res.data.code == 200) {
            let data = res.data.data
            data.forEach(item => {
              item.value = Math.floor(parseFloat(item.value) / 100) / 100
            })
            data.forEach(e => {
              e.rate=(e.rate*1).toFixed(2)
            })
            this.propertiesRatePie = data
            console.log(this.propertiesRatePie,5);
          }
        })

      },
      getLiabilityCount() {
        this.$http.get('api/tLiabilityCount/getLiabilityCount').then(res => {
            if (res.data.code == 200) {
              let data = res.data.data
              this.ecBarName1 = ['流动负债', '长期负债', '所有者权益']
              this.ecBarData1 = [Math.floor(parseFloat(data.currentLiabilityTotal) / 100) / 100, Math.floor(parseFloat(data.longLiabilitiesTotal) / 100) / 100, Math.floor(parseFloat(data.ownersEquityTotal) / 100) / 100]
            }
          }
        )
      }

    }
  }
</script>

<style scoped lang="less">
  .app-container {
    position: relative;
    width: 100%;
    height: 100%;

    .back_pattern {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 95%;
    }

    .one_title {
      position: absolute;
      top: 12%;
      width: 440px;
      height: 80px;
      padding: 8px 32px;

      .one_title_back {
        height: 100%;
        width: 100%;
      }

      .one_title_text {
        position: absolute;
        left: 15%;
        top: 50%;
        transform: translate(0, -50%);
        font-family: myTitle;
        color: #fff;
        font-size: 26px;
        line-height: 34px;
      }
    }

    .total_property {
      position: absolute;
      left: 7%;
      top: 20%;
      width: 21%;

      .total_property_back {
        width: 100%;
      }

      .total_property_text {
        position: absolute;
        top: 50%;
        left: 58%;
        transform: translate(-50%, -50%);
        width: 73%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .total_property_name {
          font-size: 18px;
          font-weight: 400;
          color: #DBE9FF;
          line-height: 25px;
        }

        .total_property_num {
          font-size: 32px;
          font-weight: bold;
          color: #FFBF2E;
          line-height: 37px;
        }
      }


      .anima_border {
        position: absolute;
        top: 48%;
        left: 2%;
        transform: translate(0, -50%);
        width: 4.3rem;
        animation: rotateAnima 5s linear infinite;
      }

      .anima_pattern {
        position: absolute;
        left: 30%;
        bottom: 19%;
        width: 25%;
        height: 5%;
        transform: skew(-45deg);

        .anima_outer {
          width: 100%;
          height: 100%;
          overflow: hidden;
          animation: hiddenAnimation 1.6s linear infinite;

          .anima_inner {
            position: relative;
            left: 0;
            top: 0;
            width: 120px;
            height: 100%;
            background: linear-gradient(to right, rgba(66, 233, 251, 1) 0%, rgba(66, 233, 251, 1) 7%, rgba(66, 233, 251, 0) 7.1%, rgba(66, 233, 251, 0) 10%,
            rgba(66, 233, 251, 1) 10.1%, rgba(66, 233, 251, 1) 17%, rgba(66, 233, 251, 0) 17.1%, rgba(66, 233, 251, 0) 20%,
            rgba(66, 233, 251, 1) 20.1%, rgba(66, 233, 251, 1) 27%, rgba(66, 233, 251, 0) 27.1%, rgba(66, 233, 251, 0) 30%,
            rgba(66, 233, 251, 1) 30.1%, rgba(66, 233, 251, 1) 37%, rgba(66, 233, 251, 0) 37.1%, rgba(66, 233, 251, 0) 40%,
            rgba(66, 233, 251, 1) 40.1%, rgba(66, 233, 251, 1) 47%, rgba(66, 233, 251, 0) 47.1%, rgba(66, 233, 251, 0) 50%,
            rgba(66, 233, 251, 1) 50.1%, rgba(66, 233, 251, 1) 57%, rgba(66, 233, 251, 0) 57.1%, rgba(66, 233, 251, 0) 60%,
            rgba(66, 233, 251, 1) 60.1%, rgba(66, 233, 251, 1) 67%, rgba(66, 233, 251, 0) 67.1%, rgba(66, 233, 251, 0) 70%,
            rgba(66, 233, 251, 1) 70.1%, rgba(66, 233, 251, 1) 77%, rgba(66, 233, 251, 0) 77.1%, rgba(66, 233, 251, 0) 80%,
            rgba(66, 233, 251, 1) 80.1%, rgba(66, 233, 251, 1) 87%, rgba(66, 233, 251, 0) 87.1%, rgba(66, 233, 251, 0) 90%,
            rgba(66, 233, 251, 1) 90.1%, rgba(66, 233, 251, 1) 97%, rgba(66, 233, 251, 0) 97.1%, rgba(66, 233, 251, 0) 100%);
          }
        }

      }
    }

    .place_line {
      display: flex;
      justify-content: space-between;
      justify-items: center;

      .place_item {
        width: 32%;
        height: 100%;
        background: rgba(24, 49, 109, 0.64);
        border: 1px solid #1680D1;
        padding: 0.8rem 0 0 0.5rem;

        .place_num {
          font-size: 26px;
          font-weight: bold;
          color: #2EFFFF;
          line-height: 30px;
        }

        .place_name {
          font-size: 14px;
          font-weight: 400;
          color: #DBE9FF;
          line-height: 20px;
        }
      }
    }

    .no-use-img {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 40%;
    }

    .place_text {
      position: absolute;

      .place_num {
        font-size: 26px;
        font-weight: bold;
        color: #FFBF2E;
        line-height: 30px;
      }

      .place_name {
        font-size: 14px;
        font-weight: 400;
        color: #DBE9FF;
        line-height: 20px;
      }

    }

    .second_title {
      width: 420px;
      border-width: 0 0 2px 0;
      border-style: solid;
      border-color: rgba(21, 54, 102, 1);

      .title_text {
        border-left: 2px solid rgba(50, 119, 234);
        padding-left: 0.5rem;
        font-size: 20px;
        font-weight: 400;
        color: #D2EAFF;
        line-height: 14px;
        margin: 0.6rem 0;
      }

      .title_pattern {
        width: 45%;
        height: 16px;
        background: linear-gradient(to right, rgba(33, 88, 178, 0) 0%, rgba(33, 88, 178, 0.4) 25%, rgba(33, 88, 178, 0.9) 80%, rgba(33, 88, 178, 0.45) 80.1%, rgba(33, 88, 178, 0.75) 90%, rgba(33, 88, 178, 0.55) 90.1%, rgba(33, 88, 178, 0.85) 100%);
      }

      .title_light {
        position: absolute;
        right: 0;
        bottom: -1px;
        width: 25%;
        height: 2px;

        border-radius: 5px;
        box-shadow: 0 0 8px 0 rgba(255, 255, 255, 1);
        background: linear-gradient(to right, rgba(255, 255, 255, 0.05) 0%, rgba(255, 255, 255, 0.85) 50%, rgba(255, 255, 255, 0.05) 100%);
      }
    }

    .loan_money {
      width: 100%;
      position: relative;

      .loan_img {
        width: 100%;
      }

      .loan_text {
        position: absolute;
        top: 50%;
        left: 45%;
        transform: translate(-50%, -50%);
        width: 65%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .loan_name {
          font-size: 18px;
          font-weight: 400;
          color: #DBE9FF;
          line-height: 25px;
        }

        .loan_num {
          font-size: 32px;
          font-weight: bold;
          color: #FFBF2E;
          line-height: 37px;
        }
      }
    }
  }


  @keyframes hiddenAnimation {
    0% {
      width: 100%;
    }
    50% {
      width: 0;
    }
    100% {
      width: 100%;

    }
  }

  @keyframes rotateAnima {
    0% {
      transform: translate(0, -50%) rotate(0deg)
    }
    100% {
      transform: translate(0, -50%) rotate(-360deg)
    }
  }
</style>
